module.exports = __webpack_public_path__ + "img/exclamation-circle.74118547.svg";